import { useState } from "react";
import { userFacingFetchError } from "../lib/trainAnalyzeUpload";

type Props = {
  className?: string;
  label?: string;
};

/** Opens Calendly popup via /api/train/calendly-config (token stays server-side). */
export function ScheduleConsultButton({
  className = "btn btn-schedule-consult",
  label = "Schedule a Consultation",
}: Props) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onClick() {
    setError(null);
    setBusy(true);
    try {
      const res = await fetch("/api/train/calendly-config", {
        headers: { Accept: "application/json" },
      });
      const data = await res.json().catch(() => ({}));
      const url =
        typeof data.scheduling_url === "string" ? data.scheduling_url.trim() : "";
      if (!res.ok || !data.enabled || !url) {
        throw new Error(
          data.message ||
            "Consultation booking is not configured (need CALENDLY_MEETING_URL and CALENDLY_MEETING_TOKEN).",
        );
      }
      const { openCalendlyPopup } = await import("../lib/calendlyPopup");
      await openCalendlyPopup(url);
    } catch (err) {
      setError(userFacingFetchError(err, "Could not open consultation booking."));
    } finally {
      setBusy(false);
    }
  }

  return (
    <span className="schedule-consult-wrap">
      <button type="button" className={className} disabled={busy} onClick={() => void onClick()}>
        {busy ? "Opening…" : label}
      </button>
      {error ? (
        <p className="model-run-error" role="alert">
          {error}
        </p>
      ) : null}
    </span>
  );
}
